import { ElementType } from 'react';
import styles from './LandingButton.module.css';
import { cx } from '@libs/classnames';
import { PolymorphicProps } from '@features/landing/shared/utils/polymorphic';

const defaultElement = 'a';

type Props<E extends ElementType = typeof defaultElement> =
  PolymorphicProps<E> & {
    size?:
      | '14r-32'
      | '14r-38'
      | '22r-40'
      | '18m-48'
      | '22m-40'
      | '22m-52'
      | '48l-59';
    color?: 'faded' | 'active-faded' | 'active-light' | 'active' | 'club';
  };

export function LandingButton({
  as,
  className,
  size = '14r-38',
  color = 'faded',
  ...rest
}: Props) {
  const Component = as ?? defaultElement;
  return (
    <Component
      className={cx(
        styles.root,
        styles[`size_${size}`],
        styles[`color_${color}`],
        className,
      )}
      {...rest}
    />
  );
}
